import { Injectable } from '@angular/core';
import { UserService } from './shared/services/user.service';
import { KeycloakService } from 'keycloak-angular';
import { StompConectionService } from './shared/socket-stomp-service/stomp-conection.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UnloadService {

  private url: string = `${environment.url}/user-management/change-session-status`;

  constructor(
    private keycloakSvc: KeycloakService,
    private stompService: StompConectionService,
  ) {
  }

  ngOnInit() {
    window.addEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
  }

  ngOnDestroy() {
    window.removeEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
  }

  beforeUnloadHandler(event: BeforeUnloadEvent) {
    this.unloadCleanup();
  }


  unloadCleanup() {
    const userId = sessionStorage.getItem('kcUserId');
    if (userId) {
      fetch(`${this.url}/${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ status: "offline" }),
        keepalive: true // keepalive permite que la solicitud continúe en segundo plano
      });

      this.stompService.disconnect();
      localStorage.clear();
      this.keycloakSvc.logout();
    }
  }
}
